import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { deleteSurveyFromSurveyBank, UseDeleteSurveyFromSurveyBankProps } from ".";

export function useDeleteSurveyFromSurveyBank(){
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: queryKeys.survey_bank._def,
        mutationFn: deleteSurveyFromSurveyBank,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.survey_bank._def, exact: false });
        }
    });
}